export interface CloudflareUploadResponse {
  // Cloudflare Stream direct upload returns e.g. { result: { id, uploadURL }, success, errors, messages }
  // But since our backend gives us a pre-signed uploadURL, the response here could be from Cloudflare or a proxy.
  [k: string]: any;
}

/**
 * Upload a video file to Cloudflare using the provided direct upload URL.
 * This performs a multipart/form-data POST with the field name "file".
 *
 * @param file The File (video) selected by the user
 * @param uploadUrl The direct upload URL obtained from backend for this battle
 */
export const uploadVideoToCloudflare = async (
  file: File,
  uploadUrl: string
): Promise<CloudflareUploadResponse> => {
  const form = new FormData();
  form.append("file", file, file.name);

  const response = await fetch(uploadUrl, {
    method: "POST",
    body: form,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to upload video: ${response.status} ${response.statusText} ${text}`);
  }

  return response;
};
